import {
  Box,
  Container,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { icons, images, videos } from "../../assets";
import { allColors } from "../../constants";
import GlobalButton from "./../../components/globalButton/index";
import { mediaUrl } from "../../constants/variables";

const featuresData = [
  // {
  //   title: "Hassle-Free Setup",
  //   description: "Trust Card can install and configure everything for you.",
  // },
  {
    title: "UK-Based Experts",
    description: "Friendly, reliable hardware experts whenever you need help.",
  },
  {
    title: "Secure & Compliant",
    description: "PCI DSS certified for safe payments.",
  },
  {
    title: "Scalable",
    description:
      "From single stores to nationwide rollouts, Trust Card grows with your business.",
  },
];

const cardData = {
  title: "Trust Benefits Your Business",
  description:
    "TailoredPay provides secure, affordable payment processing for high-risk businesses often rejected by traditional banks.",
  price: "£16.99",
  bgColor: "linear-gradient(to right, #88B7FF, #FFFFFF)",
  sideImge: images.paymentMobileImg,
  respImg: images.paymentMobileImg,
  cornerText: "Get our fastest speeds available",
  cornerCircleColor: "#FF914D",
  uniqueId: "multi-mobile",
  showVideo: false,
};

const TailoredCardTwo = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Container
      sx={{
        maxWidth: "1300px !important",
        marginTop: "40px",
        position: "relative",
      }}
    >
      <Box
        sx={{
          backgroundImage: cardData.bgColor,
          borderRadius: "35px",
          marginTop: "60px",
          padding: "30px 0px 0px 0px",
        }}
      >
        <Grid
          container
          spacing={{ xs: 0, md: 3 }}
          alignItems={{ sm: "flex-start", md: "center" }}
          sx={{
            padding: { xs: "0px 17px 10px", md: "0px 40px" },
          }}
        >
          <Grid item xs={6.7} sm={6} textAlign={"left"} mb={3}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: { xs: "5px", sm: "10px" },
                background: allColors.jasmine,
                borderRadius: { xs: "5px", sm: "10px" },
                mb: { sm: 1, md: 6 },
              }}
            >
              <Typography
                sx={{
                  color: allColors.jetBlack,
                  fontFamily: "Raleway",
                  fontWeight: "600",
                  fontSize: { xs: "11px", sm: "11px", md: "30px" },
                }}
              >
                {cardData.title}
              </Typography>
            </Box>
            <Stack spacing={1} marginTop={{ xs: "10px", md: "30px" }}>
              {featuresData.map((feature, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <img
                    src={icons.tickIcon}
                    alt="tick"
                    style={{
                      width: isSmallScreen ? "15px" : "18px",
                      height: isSmallScreen ? "15px" : "18px",
                    }}
                  />
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Raleway",
                        fontSize: { xs: "10px", sm: "10px", md: "15px" },
                        color: allColors.jetBlack,
                        fontWeight: "600",
                        mb: "2px",
                      }}
                    >
                      {feature.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Raleway",
                        fontSize: { xs: "9px", sm: "9px", md: "13px" },
                        color: allColors.jetBlack,
                        fontWeight: "400",
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Stack>
          </Grid>

          <Grid
            item
            xs={5.3}
            sm={6}
            textAlign={"center"}
            alignItems={{ xs: "center", sm: "center", md: "flex-end" }}
            display={"flex"}
            paddingLeft={{ xs: "5%", sm: "0" }}
            justifyContent={{ xs: "center", sm: "center", md: "center" }}
            mb={{ sm: 1, md: 3 }}
          >
            <img
              src={isSmallScreen ? cardData.respImg : cardData.sideImge}
              style={{
                width: isSmallScreen ? "95%" : "auto",
                height: isSmallScreen ? "77%" : "320px",
                marginLeft: isSmallScreen ? "0px" : "50px",
              }}
              alt={cardData.sideImge}
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default TailoredCardTwo;
